import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// import * as anime from 'animejs';

interface NavigationState {
  isMenuToggled: boolean;
}

type Props = RouteComponentProps<any>;

class Navigation extends React.Component<Props, NavigationState> {
  state = {
    isMenuToggled: false,
  };

  private targetElement: Element | null;

  componentDidMount() {
    this.targetElement = document.querySelector('.nav__links');
  }

  componentDidUpdate(prevProps: Props) {
    const { pathname } = this.props.location;

    if (pathname !== prevProps.location.pathname) {
      this.setState({
        isMenuToggled: false,
      });
      document.body.classList.remove('is-locked');
      document.documentElement.classList.remove('is-locked');
    }
  }

  preventDefault = (e: any) => {
    e.preventDefault();
  };

  handleMenuToggle = () => {
    const { isMenuToggled } = this.state;
    this.setState({ isMenuToggled: !isMenuToggled });

    if (isMenuToggled) {
      this.removeBodyLock();
    } else {
      document.body.classList.add('is-locked');
      document.documentElement.classList.add('is-locked');
      disableBodyScroll(this.targetElement);
    }
  };

  removeBodyLock = () => {
    document.body.classList.remove('is-locked');
    document.documentElement.classList.remove('is-locked');
    enableBodyScroll(this.targetElement);
  };

  handleBlur = (event: any) => {
    event.currentTarget ? event.currentTarget.blur() : event.srcElement.blur();
  };

  render() {
    const { isMenuToggled } = this.state;

    return (
      <nav className={`nav ${isMenuToggled ? 'is-open' : ''}`}>
        <ul className={`nav__links ${isMenuToggled ? 'is-open' : ''}`}>
          <li className="nav__links__item">
            <a href="https://auric-barrels.com/" className="nav__link">
              <img
                src={require('../assets/images/group logos/auric-barrels.svg')}
              />
            </a>
          </li>
          <li className="nav__links__item">
            {/* <a
              href="https://auric-oak.com/under-construction"
              className="nav__link"
            >
              <img
                src={require('../assets/images/group logos/auric-forest.svg')}
              />
            </a> */}
          </li>
          <li className="nav__links__item">
            <a
              href="https://auric-oak.com/under-construction"
              className="nav__link"
            >
              <img
                src={require('../assets/images/group logos/auric-nature.svg')}
              />
            </a>
          </li>
          <li className="nav__links__item">
            <a href="https://www.auric-timber.com/" className="nav__link">
              <img
                src={require('../assets/images/group logos/auric-timber.svg')}
              />
            </a>
          </li>
        </ul>
        <div className="nav__toggle">
          <button
            onClick={this.handleMenuToggle}
            className={`hamburger hamburger--elastic ${
              isMenuToggled ? 'is-active' : ''
            }`}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
        </div>
      </nav>
    );
  }
}

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/main/components/Navigation.tsx